import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

const PageContainer = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <div
      className={cn(
        'flex flex-1 flex-col gap-4 pt-4 md:pt-8 2xl:pt-10 pl-4 min-w-0 min-h-0 overflow-hidden',
        'transition-transform duration-300 ease-out will-change-transform',
        className
      )}
    >
      {children}
    </div>
  )
}

export { PageContainer }
